import { render } from "./SelectCarsBrands.vue?vue&type=template&id=827e8df2"
import script from "./SelectCarsBrands.vue?vue&type=script&lang=js"
export * from "./SelectCarsBrands.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__